__turbopack_context__.v({
  "mapContainer": "uqG40q_mapContainer",
  "mapWrapper": "uqG40q_mapWrapper",
  "orderFormat": "uqG40q_orderFormat",
  "orderFormats": "uqG40q_orderFormats",
  "outletMetaContainer": "uqG40q_outletMetaContainer",
});
